<div class="content cron-dashboard">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Cron Jobs History</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item">Cron Jobs</li>
          <li class="breadcrumb-item active" aria-current="page">History</li>
        </ol>
      </nav>
    </div>
    <!-- <div class="ms-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="openRunModal()">
        <i class="ti ti-circle-plus me-2"></i>Run Cron
      </button>
    </div> -->
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
      >
        <h5>Cron Job List</h5>
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <!-- Filters -->
          <div class="me-3" *ngIf="logs.length > 0">
            <select
              data-extension-safe
              class="form-select form-select-sm col-md-1"
              id="entries"
              [(ngModel)]="pageLimit"
              (change)="onPageLimitChange()"
            >
              <!-- <option selected disabled>Show Entries Per Page</option> -->
              <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
            </select>
          </div>
          <div class="me-3">
            <div class="input-icon-end position-relative">
              <!-- <span>From</span> -->
              <input
                type="date"
                [(ngModel)]="filterFromDate"
                (change)="onFilterChange()"
                class="form-control"
              />
            </div>
          </div>

          <div class="me-3">
            <div class="input-icon-end position-relative">
              <!-- <span>To</span> -->
              <input
                type="date"
                [(ngModel)]="filterToDate"
                (change)="onFilterChange()"
                class="form-control"
              />
            </div>
          </div>
          <!-- <div class="dropdown me-3">
            <select
              class="form-select"
              id="selectedCouponType"
              [(ngModel)]="filterCronName"
              (change)="onFilterChange()"
            >
              <option value="">All Crons</option>
              <option *ngFor="let cron of cronOptions" [value]="cron.value">
                {{ cron.label }}
              </option>
            </select>
          </div> -->

          <div class="dropdown me-3">
            <select class="form-select" [(ngModel)]="filterStatus" (change)="onFilterChange()">
              <option value="">All Status</option>
              <option *ngFor="let s of statusOptions" [value]="s">{{ s | capitalize }}</option>
            </select>
          </div>
          <!-- <div class="filters">
            <select [(ngModel)]="filterCronName" (change)="onFilterChange()">
              <option value="">All Crons</option>
              <option *ngFor="let c of availableCrons" [value]="c">{{ c }}</option>
            </select>

            <select [(ngModel)]="filterStatus" (change)="onFilterChange()">
              <option value="">All Status</option>
              <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
            </select>

            <input
              type="text"
              placeholder="Business ID"
              [(ngModel)]="filterBusinessId"
              (change)="onFilterChange()"
            />

            <input type="date" [(ngModel)]="filterFromDate" (change)="onFilterChange()" />
            <span>to</span>
            <input type="date" [(ngModel)]="filterToDate" (change)="onFilterChange()" />
          </div> -->
        </div>
      </div>
      <!-- Table -->
      <div class="card-body p-0">
        <div class="custom-datatable-filter table-responsive">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Cron</th>
                <th>Date</th>
                <th>Business</th>
                <th>Status</th>
                <th>Progress</th>
                <!-- <th>Step</th> -->
                <th>Triggered By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of logs">
                <td>{{ getCronLabel(log.cronName) }}</td>
                <td>{{ log.targetDate | date: 'dd MMM yyyy' }}</td>
                <td>{{ log.businessName }}</td>
                <td>
                  <span [ngClass]="statusClass(log.status)">{{ log.status | capitalize }}</span>
                </td>
                <td class="progress-cell">
                  <div class="progress-bar-bg">
                    <div class="progress-bar-fill" [style.width.%]="log.progressPercent"></div>
                  </div>
                  <span class="progress-text">{{ log.progressPercent }}%</span>
                </td>
                <!-- <td>{{ log.currentStep || '-' }}</td> -->
                <td>{{ log.username }}</td>
                <td class="actions-cell">
                  <button *ngIf="canStop(log.status)" class="btn-danger-sm" (click)="stop(log)">
                    Stop
                  </button>
                  <button *ngIf="canPause(log.status)" class="btn-warn-sm" (click)="pause(log)">
                    Pause
                  </button>
                  <button
                    *ngIf="canRestart(log.status)"
                    class="btn-secondary-sm"
                    (click)="restart(log)"
                  >
                    Restart
                  </button>
                  <!-- <button class="btn-link-sm" (click)="viewDetails(log)">
                    <i class="ti ti-eye"></i>
                  </button> -->
                  <a href="javascript:void(0);" class="me-2" (click)="viewDetails(log)"
                    ><i class="ti ti-eye"></i
                  ></a>
                </td>
              </tr>
              <tr *ngIf="!loading && logs.length === 0">
                <td colspan="8" class="empty-row">No cron runs found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Pagination -->
      <!-- <div class="pagination" *ngIf="totalCount > 0"> -->
      <!-- <button (click)="changePage(-1)" [disabled]="page === 1">Prev</button>
        <span>Page {{ page }} of {{ total / limit | number: '1.0-0' }}</span>
        <button (click)="changePage(1)" [disabled]="page * limit >= total">Next</button> -->

      <div class="d-flex align-items-center justify-content-between ms-2">
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
      <!-- </div> -->

      <!-- pagination -->
      <!-- <ng-container *ngIf="coupons$ | async as coupons">
      <ng-container *ngIf="coupons.length > 0">
        <div class="d-flex align-items-center justify-content-between ms-2">
          <div>
            Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
            {{ totalCount }} entries
          </div>
          <div class="has-text-centered mt-3">
            <app-pagination
              [currentPage]="currentPage"
              [pageSize]="pageLimit"
              [totalRows]="totalCount"
              (pageChange)="onPageChange($event)"
            ></app-pagination>
          </div>
        </div>
      </ng-container>
    </ng-container> -->
      <!-- pagination end -->
    </div>
  </div>

  <!-- Run Modal -->
  <!-- <div
    class="modal-overlay"
    *ngIf="showRunModal"
    role="button"
    tabindex="0"
    aria-label="Close modal"
    (click)="closeRunModal()"
    (keydown.enter)="closeRunModal()"
    (keydown.escape)="closeRunModal()"
  >
    <div
      class="modal"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <h3>Run Cron</h3>

      <label for="runCronName">Cron Type</label>
      <select [(ngModel)]="runCronName">
        <option *ngFor="let c of availableCrons" [value]="c">{{ getCronLabel(c) }}</option>
      </select>

      <label for="">Mode</label>
      <div class="mode-toggle">
        <button [class.active]="runMode === 'single'" (click)="runMode = 'single'">
          Single Date
        </button>
        <button [class.active]="runMode === 'range'" (click)="runMode = 'range'">Date Range</button>
      </div>

      <ng-container *ngIf="runMode === 'single'">
        <label for="runDate">Date (blank = yesterday)</label>
        <input type="date" [(ngModel)]="runDate" />
      </ng-container>

      <ng-container *ngIf="runMode === 'range'">
        <label for="runStartDate">Start Date</label>
        <input type="date" [(ngModel)]="runStartDate" />
        <label for="runEndDate">End Date</label>
        <input type="date" [(ngModel)]="runEndDate" />
      </ng-container>

      <label for="runBusinessId">Business ID (blank = all businesses)</label>
      <input type="text" [(ngModel)]="runBusinessId" placeholder="Optional" />

      <p class="error-text" *ngIf="runError">{{ runError }}</p>

      <div class="modal-actions">
        <button class="btn btn-ligt" (click)="closeRunModal()">Cancel</button>
        <button class="btn btn-primary" (click)="submitRun()" [disabled]="runSubmitting">
          {{ runSubmitting ? 'Starting...' : 'Run' }}
        </button>
      </div>
    </div>
  </div> -->

  <!-- Details Drawer -->
  <div
    class="drawer-overlay"
    *ngIf="selectedLog"
    role="button"
    tabindex="0"
    aria-label="Close details"
    (click)="closeDetails()"
    (keydown.enter)="closeDetails()"
    (keydown.escape)="closeDetails()"
  >
    <div
      class="drawer"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="drawer-header">
        <h3>
          {{ getCronLabel(selectedLog.cronName) }} —
          {{ selectedLog.targetDate | date: 'dd MMM yyyy' }}
        </h3>
        <!-- <button class="btn-link-sm" (click)="closeDetails()">Close</button> -->
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeDetails()"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>

      <div class="drawer-summary">
        <p><strong>Status:</strong> {{ selectedLog.status | capitalize }}</p>
        <p>
          <strong>Progress:</strong> {{ selectedLog.processedItems }} /
          {{ selectedLog.totalItems }}
        </p>
        <p *ngIf="selectedLog.errorMessage">
          <strong>Error:</strong> {{ selectedLog.errorMessage }}
        </p>
        <div *ngIf="selectedLog.summary">
          <strong>Summary:</strong>
          <ul>
            <li *ngFor="let key of selectedLog.summary | keyvalue">
              {{ key.key }}: {{ key.value }}
            </li>
          </ul>
        </div>
      </div>

      <h4>Failures / Edge Cases ({{ selectedLogDetails.length }})</h4>
      <table class="details-table" *ngIf="selectedLogDetails.length > 0">
        <thead>
          <tr>
            <th>User</th>
            <th>Status</th>
            <th>Action</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of selectedLogDetails">
            <td>{{ d.userId }}</td>
            <td>{{ d.status }}</td>
            <td>{{ d.action }}</td>
            <td>{{ d.message }}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="selectedLogDetails.length === 0" class="empty-row">No failures recorded 🎉</p>
    </div>
  </div>
</div>
<!-- </div>
    </div>
  </div>
</div> -->
